<div class="two-factor-wrapper container-fluid">
    <div class="row justify-content-md-center m-top-100">
        <div class="col-12">
            <iframe id="duo_iframe"></iframe>
        </div>
    </div>
</div>
